import './CategoryRow.scss';
import React from 'react';
import clsx from 'clsx';
import { MdExpandMore } from 'react-icons/md';

interface IProps {
    name: string;
    totalWeight: number | null;
    isCollapsed: boolean;
    colSpan: number;
    /** Принимает имя категории — даёт parent'у одну стабильную ссылку
     *  через useCallback (без замыкания на cat.name), что нужно для memo. */
    onToggle: (name: string) => void;
}

/**
 * Sticky-row группировки по категории: chevron + «Категория НАЗВАНИЕ» слева
 * + «вес ∑ N» справа. Sticky-блоки внутри cell с colspan чтобы при гор. скролле
 * label оставался у левого края, а Σ-сумма — у правого.
 *
 * Δ при collapse меняет поворот шеврона через class `is-collapsed`.
 */
const CategoryRowInner: React.FC<IProps> = ({ name, totalWeight, isCollapsed, colSpan, onToggle }) => (
    <tr
        className={clsx('ws-row-cat', { 'is-collapsed': isCollapsed })}
        onClick={() => onToggle(name)}
        aria-expanded={!isCollapsed}
    >
        <td colSpan={colSpan}>
            <span className="ws-row-cat__inner">
                <span className="ws-row-cat__chev">
                    <MdExpandMore size="18px" />
                </span>
                <span className="ws-row-cat__label">
                    Категория <b>{name}</b>
                </span>
            </span>
            {totalWeight != null && (
                <span className="ws-row-cat__sum" title="Суммарный вес критериев категории">
                    вес{' '}
                    <span className="ws-row-cat__sum-sigma" aria-hidden>
                        ∑
                    </span>{' '}
                    <b className="ws-row-cat__sum-value">
                        {totalWeight.toLocaleString('ru-RU', { maximumFractionDigits: 4 })}
                    </b>
                </span>
            )}
        </td>
    </tr>
);

export const CategoryRow = React.memo(CategoryRowInner);
